import { BASE_IMPORT_DATA } from "@/Modals/Profiles/BaseImport/baseImportData";
import React from "react";
import { columns } from "./Columns";
import { playerTypesApi } from "@/apis/apis";
import BaseTable from "./BaseTable";
import PlayerTypeModal from "@/Modals/Profiles/PlayerTypes/Modal";

export default function PlayerTypesPage() {
  return (
    <BaseTable
      label="Player Types"
      apiURL={playerTypesApi}
      columns={columns()}
      ModalComponent={PlayerTypeModal}
      importData={BASE_IMPORT_DATA.PLAYER_TYPES}
      enableSortData={true}
    />
  );
}
